import { NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormDefinitionModel } from '../../dynamic-form-components/shared-models/form-definition.model';
import { FormComponent } from '../form/form.component';
import { FormChange, FormSave } from '../form/form.model';

@Component({
  selector: 'gsm-form-history',
  templateUrl: './form-history.component.html',
  styleUrls: ['./form-history.component.scss'],
  standalone: true,
  imports: [
    NgFor,
    FormComponent
  ]
})
export class FormHistoryComponent implements OnChanges {
  @Input() formHistoryData: FormDefinitionModel[];
  @Input() selectedTaskId: string;
  @Input() isAbschluss: boolean;
  @Input() loadingTaskId: string;
  @Input() uploadingTaskId: string;
  @Input() uploadBytesLoaded = 0;
  @Input() uploadBytesTotal = 0;

  @Output() customEvent = new EventEmitter<CustomEvent>();
  @Output() saveEvent = new EventEmitter<FormSave>();
  @Output() editEvent = new EventEmitter<string>();
  @Output() cancelEvent = new EventEmitter<string>();
  @Output() cancelUploadEvent = new EventEmitter();
  @Output() formChangeEvent = new EventEmitter<FormChange>();

  ngOnChanges({formHistoryData}: SimpleChanges) {
    if (typeof this.formHistoryData === 'string') {
      this.formHistoryData = JSON.parse(this.formHistoryData as string);
    }
  }

  isMatchingForm(form: FormDefinitionModel, taskId: string) {
    return !!taskId && taskId === form.taskId;
  }

  isFormEditable(form: FormDefinitionModel): boolean {
    // if form has no task ID, it's not editable.
    // if there is no selected task ID, all forms are editable.
    // if there is a selected task ID, only form with matching task ID is editable.
    return !!form.taskId && (this.selectedTaskId === null || this.selectedTaskId === form.taskId);
  }

  handleChildFormChange(event: FormChange, taskId: string) {
    this.formChangeEvent.emit({
      ...event,
      taskId
    });
  }
}
